import React from "react"
import Typography from "@material-ui/core/Typography"

const AffiliateDisclosure = () => (
  <Typography variant="body2" gutterBottom>
    <em>
      As an Amazon Associate we earn from qualifying purchases. Amazon links on
      this page are affiliate links, at no extra cost to you.
    </em>
  </Typography>
)

export default AffiliateDisclosure
